import { Card } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { numberWithCommas } from 'utils/NumberCommaSeprator';
import { LoadingAnimation } from 'components/common';

const CardContainer = styled(Card)`
	height: 100%;
	display: flex;
	align-items: center;
	text-align: center;
	justify-content: center;
`;

const CountNumber = styled.span`
	font-size: 40px;
	font-weight: 500;
	font-family: 'Montserrat';
`;

function AverageTrips({ averageTrips, isLoading }) {
	return (
		<CardContainer>
			{isLoading ? (
				<LoadingAnimation visible={isLoading} animationID="AverageTrips" />
			) : (
				<>
					<CountNumber>{numberWithCommas(averageTrips)}</CountNumber>
					<p style={{ fontWeight: '400' }}>Average Trips per day</p>
				</>
			)}
		</CardContainer>
	);
}

AverageTrips.propTypes = {
	averageTrips: PropTypes.object,
	isLoading: PropTypes.bool,
};

export default AverageTrips;
